import type { InferRequestType } from "hono/client";
import { apiClient } from "./apiClient";

const crossSectionDxfApi =
	apiClient.v2.api[":siteId"]["cross-section"][":crossSectionId"].dxf;

/** Request body (derived from the v2-server schema; same shape as v1 createDXF). */
export type CrossSectionDxfBody = InferRequestType<
	(typeof crossSectionDxfApi)["$post"]
>["json"];

/**
 * Generate the cross-section DXF on v2-server.
 * @returns DXF content; throws on a non-2xx response (like axios does for v1)
 */
export const postCrossSectionDxf = async (
	siteId: string,
	crossSectionId: string | number,
	body: Readonly<CrossSectionDxfBody>,
): Promise<Blob> => {
	const res = await crossSectionDxfApi.$post({
		param: { siteId, crossSectionId: String(crossSectionId) },
		json: body,
	});
	if (!res.ok) {
		throw new Error(`Cross-section DXF request failed: ${res.status}`);
	}
	return res.blob();
};
